export default __webpack_public_path__ + "static/143-min-min-ce68ad9d7a449a585ace73552c286a1b.jpg";